"use strict";

exports.__esModule = true;
exports.Typing = void 0;

var Term_1 = require("../Term");

exports.Typing = new Term_1.Term('Typing', 'TYPING', null, {
  cast: function cast(typing, value) {
    try {
      switch (typing) {
        case '#arr':
          {
            if (value[0] === '[' && value[value.length - 1] === ']') {
              var inner = value.substring(1, value.length - 1);
              var items = inner.split(',');
              return items;
            }

            console.warn('Invalid value passed to Typing for #arr', value);
          }

        case '#bool':
          return value === 'true' ? true : false;

        case '#int':
          return parseInt(value);
      }
    } catch (e) {
      console.warn('Error attempting to type', value, e);
    }

    return value;
  }
});